import { SP_ADDRESS } from "../actionTypes";

export default function spAddressReducer(state = null, action) {
  const { GET, ADD, UPDATE, RESET, TOGGLE } = SP_ADDRESS;

  switch (action.type) {
    case GET:
      return action.payload;

    case ADD:
      return action.payload;

    case UPDATE:
      return state.map((item) =>
        item.id === action.payload.id ? action.payload : item
      );

    case TOGGLE:
      return state.map((item) =>
        item.id !== action.payload.id
          ? item
          : { ...item, enabled: !item.enabled }
      );

    case RESET:
      return null;

    default:
      return state;
  }
}
